<template>
  <div>
    <div class="flex items-center gap-2 overflow-auto md:overflow-hidden custom-scroll">
      <div v-for="(filter, index) in filterList" :key="index" class="">
        <Chip :value="filter.value" :selected="selectedFilters.includes(filter.value)"
          @onSelect="handleFilterChange(filter.value, true)" @onDeselect="handleFilterChange(filter.value, false)"
          class="w-max">
          {{ filter.name }}
        </Chip>
      </div>
    </div>

  </div>
</template>

<script>
import Chip from "@/components/base/Chip";
export default {
  name: 'ResourcesFilter',
  components: {
    Chip,
  },
  props: {
    selected: {
      type: Array,
      default: (() => [])
    }
  },
  data() {
    return {
      filterList: [
        { name: "Driving", value: 'driving' },
        { name: "Charging", value: 'charging' },
        { name: "Digital Key", value: 'digital_key' },
        { name: "Rental Process", value: 'rental_process' },
        { name: "Insurance", value: 'insurance' }
      ],
      selectedFilters: this.selected
    };
  },
  methods: {
    handleFilterChange(value, isSelected) {
      this.selectedFilters = isSelected
        ? [...new Set([...this.selectedFilters, value])]
        : this.selectedFilters.filter(filter => filter !== value);

      const newQuery = { ...this.$route.query };
      if (this.selectedFilters.length) {
        newQuery.tags = JSON.stringify(this.selectedFilters);
      } else {
        delete newQuery.tags; // Remove `tags` when no filters are selected
      }

      if (JSON.stringify(this.$route.query) !== JSON.stringify(newQuery)) {
        this.$router.replace({ query: newQuery });
      }

      this.$emit("onChange", [...this.selectedFilters]);
    }
  },
  watch: {
    selected(newSelected) {
      this.selectedFilters = newSelected;
    }
  }
}
</script>

<style scoped>
/* Hide scrollbar in WebKit browsers (Chrome, Safari) */
.custom-scroll::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar in Firefox */
.custom-scroll {
  scrollbar-width: none;
}

/* Keep overflow functionality */
.custom-scroll {
  overflow-x: auto;
  -ms-overflow-style: none;
  /* IE and Edge */
}
</style>
